import type { EnabledAccount } from './types';

/**
 * filterEnabledAccountsFn
 * used to filter enabled accounts by userId, projectId, or projectName in the EnabledAccounts client paginated table
 */
export const filterEnabledAccountsFn = (enabledAccount: EnabledAccount, filter: string) => {
  return (
    enabledAccount.userId.toLowerCase().includes(filter.toLowerCase()) ||
    enabledAccount.projectName.toLowerCase().includes(filter.toLowerCase()) ||
    enabledAccount.projectId.toString().includes(filter)
  );
};
